import { PermissaoEnum } from './../../models/role.enum';
import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MenuService } from './menu.service';
import { DividerComponent } from '../divider/divider.component';
import { ButtonComponent } from '../button/button.component';
import { TooltipDirective } from '../directives/tooltip.directive';
import { User } from '../../models/authentication.interface';
import { UserService } from '../services/user/user.service';
import { permissaoBehavior } from '../../models/role.enum';
import { AgendaComponent } from '../../private/admin/pages/agenda/agenda/agenda.component';
import { DadosAlunoComponent } from '../../private/admin/pages/app-mobile/dados-aluno/dados-aluno.component';
import { FichaMedicaComponent } from '../../private/admin/pages/app-mobile/ficha-medica/ficha-medica.component';
import { HistoricoComponent } from '../../private/admin/pages/app-mobile/historico/historico.component';
import { DocumentosComponent } from '../../private/admin/pages/app-mobile/documentos/documentos.component';
import { FotosAlunoComponent } from '../../private/admin/pages/app-mobile/dados-aluno/components/fotos-aluno/fotos-aluno.component';
import { StorageServiceService } from '../storage/storage-service.service';

@Component({
  selector: 'menu',
  standalone: true,
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  imports: [
    CommonModule,
    RouterLink,
    TooltipDirective,
    RouterModule,
    AgendaComponent,
    DadosAlunoComponent,
    FichaMedicaComponent,
    HistoricoComponent,
    DocumentosComponent,
    FotosAlunoComponent,
  ],
})
export class MenuComponent implements OnInit {
  isOpen = true;
  isMobile = false;
  openMoreMenu!: any;
  user!: User;
  menu: Menu[] = [];
  more_menu: any[] = [];
  role: permissaoBehavior | undefined;
  loading: boolean = false;
  component: string = 'Todos';
  dadosAluno: component[] = [
    {
      label: 'Dados do Aluno',
    },
    {
      label: 'Ficha Médica',
    },
    {
      label: 'Fotos do Aluno',
    },
    {
      label: 'Histórico',
    },
    {
      label: 'Documentos',
    },
  ];
  constructor(
    private service: MenuService,
    private readonly userService: UserService,
    private readonly storageService: StorageServiceService,
  ) {
    this.service._menu.subscribe((menu) => (this.menu = menu));

    this.userService.permissao.subscribe((value) => {
      if (value !== undefined) {
        this.role = value;
      } else {
        if(this.storageService.obterPermissao() !== undefined) {
          this.role = this.storageService.obterPermissao() as permissaoBehavior;
        }
      }
    });
  }

  ngOnInit(): void {
    this.more_menu = [
      {
        icon: 'school',
        label: 'Aluno',
        component: 'aluno',
        checked: false,
      },
      {
        icon: 'calendar_month',
        label: 'Agenda',
        component: 'calendario',
        checked: false,
      },
    ];

    this.service.loading.subscribe((value) => {
      if (value) {
        this.loading = value;
      }
    });
  }

  openClose() {
    this.isOpen = !this.isOpen;
  }

  mostrarComponent(component: string) {
    this.component = component;
  }

  fecharMenu() {
    this.isMobile = false;
  }

  openMenuMobile(active?: string) {
    this.openMoreMenu = active;
    if (active) {
      this.component = active === 'calendario' ? 'calendario' : 'Todos';
    }
    this.isMobile = !this.isMobile;
  }

  back() {
    if (this.openMoreMenu === 'aluno' && this.component === 'Todos') {
      this.openMenuMobile();
    } else {
      this.component = 'Todos';
    }
  }

  protected readonly PermissaoEnum = PermissaoEnum;
}

export interface Menu {
  icon: string;
  label: string;
  route: string;
  checked: boolean;
}

export interface component {
  label: string;
}
